<template>
  <!-- 用户授权书 -->
  <div class="my-agree">
    <div class="right-box">
      <p class="title">《{{ valuetxt }}》</p>
      <div v-html="dataResult"></div>
    </div>
    <div class="auth" v-if="userInfo.id && (!isAgree || isAgree !== '0') && show">
      <div class="txt-auth">
        <span>授权人：</span><span class="txt-line">{{ userInfo && userInfo.realName }}</span>
      </div>
      <div class="txt-auth">
        <span>日期：</span><span class="txt-line">{{timetxt}}</span>
      </div>
    </div>
    <div class="right-box" v-else-if="isAgree === '0'">
      <van-radio-group v-model="checked" direction="horizontal">
        <van-radio icon-size="14px" checked-color="#EB1700" name="1"
          >我已经阅读以上协议，同意协议中的所有内容</van-radio
        >
      </van-radio-group>
      <div
        class="mt20 agree_btn"
        :class="!checked ? 'noActive' : ''"
        @click="handleChange"
      >
        确定
      </div>
    </div>
  </div>
</template>

<script>
import withRouteTracking from '@/utils/withRouteTracking'
import { dataDictionary, checkAgreeUserOk, queryAgreeByUserId } from '@/api/api'
import { beforeLoginFun } from '@/utils/util'
const UserProfile = {
  name: 'agree',
  data() {
    return {
      checked: false,
      dataResult: {},
      valuetxt: '',
      timetxt: '',
      show: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    isUserInfo() {
      return this.$route.query.isUserInfo
    },
    isAgree() {
      return this.$route.query.isAgree
    }
  },
  mounted() {
    this.handleLoad()
  },
  methods: {
    handleLoad() {
      queryAgreeByUserId(this.userInfo.id).then(res => {
        if (res.data) {
          this.show = true
          this.timetxt = this.$moment(parseInt(res.data.createTime)).format('YYYY-MM-DD')
        }
      })
      const params = {
        typeCode: 'PRIVACYAGREEMENT',
        dataStatus: 1,
      }
      dataDictionary(params).then((res) => {
        if (res.code === 0) {
          this.dataResult = res.data[0].explainContent
          this.valuetxt = res.data[0].value
        }
      })
    },
    decode(urlTxt) {
      try {
        // 使用atob函数解码Base64
        return atob(urlTxt)
      } catch (error) {
        console.error('解码失败:', error)
      }
    },
    handleChange() {
      if (!this.checked) {
        this.$toast('请先勾选隐私协议！')
        return
      }
      checkAgreeUserOk(this.userInfo.id)
        .then((res) => {
          if (res.code === 0) {
            let iepLoginResult = JSON.parse(sessionStorage.getItem('iepLoginResult'))
            iepLoginResult.isAgree = '1'
            sessionStorage.setItem('iepLoginResult', JSON.stringify(iepLoginResult))
            // const { backurl } = iepLoginResult
            // if (backurl) {
            //   window.location.href = atob(backurl)
            //   return
            // }
            beforeLoginFun()
          } else {
            this.$router.push({
              path: '/home',
            })
          }
        })
        .catch((err) => {
          console.error(err)
          this.$router.push({
            path: '/home',
          })
        })
    },
  },
}
// 这块是路由跟踪埋点的功能，具体实现在utils/withRouteTracking.js
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.my-agree {
  background: url("../../assets/images/article/agree-bg.png") no-repeat center
    center / 100% 100%;
  width: 100%;
  height: 148px;
  .auth {
    text-align: right;
    padding: 20px;
    box-sizing: border-box;
    .txt-auth {
      display: block;
      line-height: 32px;
      .txt-line {
        padding-bottom: 2px;
        border-bottom: 1px solid #000;
      }
    }
  }
  .right-box {
    padding: 24px 14px 18px 16px;
    .title {
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      font-size: 24px;
      color: #1a1a1a;
      text-align: center;
      margin-bottom: 10px;
    }
    .agree_btn {
      margin: 20px auto;
      width: 120px;
      height: 30px;
      background: #ffefe7;
      border-radius: 13px 13px 13px 13px;
      font-family: Helvetica, Helvetica;
      font-weight: 400;
      font-size: 14px;
      color: #ff5a0b;
      line-height: 29px;
      text-align: center;
    }
    .van-radio--horizontal {
      margin-right: none !important;
    }
    .noActive {
      background: #f2f3f7;
      color: #6a7481;
      pointer-events: none !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/agree copy.vue